var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Callout, Flex, Input, Link, SelectField, Text } from '@homeexchange/design';
import i18n from '../../../i18n';
import { bindActionCreators } from 'redux';
import { saveBillingAddress } from '../../../actions/billingAddress';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
import Analytics from '../../../utils/analytics';
function BillingAddressFields(props) {
    var _this = this;
    var context = props.context, legalEntity = props.legalEntity, onChange = props.onChange, onError = props.onError, saveBillingAddress = props.saveBillingAddress;
    var _a = useState(props.billingAddress), billingAddress = _a[0], setBillingAddress = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState({}), errors = _c[0], setErrors = _c[1];
    var _d = useState(false), hasApiError = _d[0], setHasApiError = _d[1];
    var countries = legalEntity.countries;
    var redirectToLearnMorePage = function () {
        Analytics.trackGTM('button', {
            event_data: {
                action: 'click',
                text: 'learn_more',
                area: context === 'modal'
                    ? 'enterbillinginformation_modale'
                    : 'enterbillinginformation_embeddedform'
            }
        });
    };
    useEffect(function () {
        setBillingAddress(props.billingAddress);
    }, [props.billingAddress]);
    var locale = i18n.language || 'en';
    var regionNames = useMemo(function () { return new Intl.DisplayNames([locale], { type: 'region' }); }, [locale]);
    var countriesOptions = useMemo(function () {
        return countries
            .map(function (isoCode) { return ({
            id: isoCode,
            value: isoCode,
            displayedValue: regionNames.of(isoCode.toUpperCase()) || isoCode
        }); })
            .sort(function (a, b) {
            return a.displayedValue.localeCompare(b.displayedValue, locale, { sensitivity: 'base' });
        });
    }, [countries, locale, regionNames]);
    var handleFieldChange = useCallback(function (fieldName, value) {
        setBillingAddress(function (prevBillingAddress) {
            var _a;
            return (__assign(__assign({}, prevBillingAddress), (_a = {}, _a[fieldName] = value, _a)));
        });
        setErrors(function (prevErrors) {
            if (!prevErrors[fieldName]) {
                return prevErrors;
            }
            var _a = prevErrors, _b = fieldName, _removed = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return rest;
        });
    }, []);
    var clearFormErrors = useCallback(function () {
        setErrors({});
    }, []);
    var validateForm = useCallback(function () {
        var validationErrors = {};
        var fieldsToValidate = [
            ['address', 'billing:validation_error.card-address.empty'],
            ['city', 'billing:validation_error.card-city.empty'],
            ['zip_code', 'billing:validation_error.card-zipcode.empty'],
            ['iso_country_code', 'billing:validation_error.card-country.empty']
        ];
        fieldsToValidate.forEach(function (_a) {
            var field = _a[0], translationKey = _a[1];
            var value = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress[field];
            if (!"".concat(value !== null && value !== void 0 ? value : '').trim()) {
                validationErrors[field] = i18n.t(translationKey);
            }
        });
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    }, [billingAddress]);
    var handleSave = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var isValid, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    setHasApiError(false);
                    trackAction('save_information');
                    isValid = validateForm();
                    if (!isValid) return [3 /*break*/, 4];
                    clearFormErrors();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, saveBillingAddress(billingAddress)];
                case 2:
                    _a.sent();
                    trackAction('save_information_success');
                    if (onChange) {
                        onChange(billingAddress);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setHasApiError(true);
                    trackAction('save_information_error');
                    if (onError) {
                        onError();
                    }
                    return [3 /*break*/, 4];
                case 4:
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [clearFormErrors, validateForm]);
    var trackAction = function (text) {
        Analytics.trackGTM('button', {
            event_data: {
                text: text,
                action: 'click',
                area: context === 'modal'
                    ? 'enterbillinginformation_modale'
                    : 'enterbillinginformation_embeddedform'
            }
        });
    };
    return (React.createElement(Flex, { direction: "column", gap: "4", isFullWidth: true },
        React.createElement(Input, { isFullWidth: true, label: i18n.t('subscription:address.label'), status: (errors === null || errors === void 0 ? void 0 : errors.address) ? 'error' : undefined, message: errors === null || errors === void 0 ? void 0 : errors.address, name: "address", value: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.address) || '', onChange: function (e) {
                return handleFieldChange('address', e.target.value);
            } }),
        React.createElement(Flex, { direction: "row", flexGrow: true, gap: "4", isFullWidth: true },
            React.createElement(Input, { isFullWidth: true, label: i18n.t('subscription:credit_card_city.label'), status: (errors === null || errors === void 0 ? void 0 : errors.city) ? 'error' : undefined, message: errors === null || errors === void 0 ? void 0 : errors.city, name: "city", value: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city) || '', onChange: function (e) {
                    return handleFieldChange('city', e.target.value);
                } }),
            React.createElement(Input, { isFullWidth: true, label: i18n.t('subscription:credit_card_zipcode.label'), status: (errors === null || errors === void 0 ? void 0 : errors.zip_code) ? 'error' : undefined, message: errors === null || errors === void 0 ? void 0 : errors.zip_code, name: "zip_code", value: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.zip_code) || '', onChange: function (e) {
                    return handleFieldChange('zip_code', e.target.value);
                } })),
        React.createElement(SelectField, { ariaLabel: "Select a country", items: countriesOptions, maxVisibleItems: 7, label: i18n.t('subscription:credit_card_country.label'), labelHelperContent: React.createElement(Trans, { i18n: i18n, i18nKey: "subscription:country_label_helper", components: {
                    learnMoreLink: (React.createElement(Link, { target: "_blank", href: i18n.t('url:link_learn-more-country-select'), onClick: redirectToLearnMorePage }))
                } }), placeholder: i18n.t('subscription:country_label_placeholder'), isFullWidth: true, status: (errors === null || errors === void 0 ? void 0 : errors.iso_country_code) ? 'error' : undefined, message: errors === null || errors === void 0 ? void 0 : errors.iso_country_code, value: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.iso_country_code) || '', onChange: function (value) { return handleFieldChange('iso_country_code', value); } }),
        hasApiError && (React.createElement(Callout, { hasIcon: true, status: "error" },
            React.createElement(Text, { className: "callout-title", isBold: true, isSpan: true }, i18n.t('subscription:billing.editinformation.error.calloutTitle')),
            React.createElement(Text, { dangerouslySetInnerHTML: {
                    __html: i18n.t('billing:payment-method.addmethod.error.calloutBody', {
                        link: i18n.t('url:contact_us')
                    })
                } }))),
        React.createElement(Button, { className: "mt-4", isLoading: isLoading, onClick: handleSave, text: i18n.t('subscription:global_save_informations'), isFullWidth: true })));
}
var mapStateToProps = function (state) { return ({
    legalEntity: state.legalEntity
}); };
var mapDispatchToProps = function (dispatch) { return ({
    saveBillingAddress: bindActionCreators(saveBillingAddress, dispatch)
}); };
export default connect(mapStateToProps, mapDispatchToProps)(BillingAddressFields);
